/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortsSurvey.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useEffect } from 'react';
import { UserAttributeKeys } from '../../userAttributes';
import { useUserAttribute } from '../../userAttributes/userAttributesQueries.migrated';
import enviro from 'enviro';
import Raven from 'raven-js';
// @ts-expect-error Could not find a declaration file for module 'feedback-loader/useFeedbackLoader'.
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
const SURVEY_ID_PROD = 1134;
const SURVEY_ID_QA = 429;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortsSurvey.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const ShortsSurvey = () => {
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();
  const {
    userAttribute: hasViewedShortSurvey,
    setUserAttribute: setHasViewedShortSurvey,
    userAttributeLoading: hasViewedShortSurveyLoading,
    userAttributesError: hasViewedShortSurveyError
  } = useUserAttribute(UserAttributeKeys.HAS_VIEWED_SHORT_SURVEY);
  useEffect(() => {
    if (hasViewedShortSurvey || hasViewedShortSurveyLoading || hasViewedShortSurveyError || !clientLoaded) {
      return;
    }
    loadSurvey(enviro.isQa() ? SURVEY_ID_QA : SURVEY_ID_PROD, 'CSAT');
    setHasViewedShortSurvey(true).catch(Raven.captureException.bind(Raven));
  }, [hasViewedShortSurvey, hasViewedShortSurveyLoading, hasViewedShortSurveyError, clientLoaded, loadSurvey, setHasViewedShortSurvey]);
  return null;
};